import { TableCell } from '@mui/material';
import { styled } from '@mui/system';

const WideTableCell = styled(TableCell)`
  width: 100%;
`;
export default WideTableCell;
